import React from 'react'
import './Forms.scss'

const FormDetails = ({ id, className, children }) => {
  return children ? (
    <div
      data-testid="div-FormDetails"
      className={`Forms ${className || ''}`}
      id={id || ''}
    >
      {children}
    </div>
  ) : null
}

export default FormDetails
